const trackedCollectionLinks = new WeakSet();
const trackedCollectionModules = new WeakSet();
const trackedCollectionModuleLinks = new WeakSet();

const cp_collection_title = document.querySelector('.breadcrumbs__list li:last-child a');
const cp_product_category = cp_collection_title?.textContent?.trim() || 'unknown_collection';

const buildModulePayload = (target, interactionType) => {
  const moduleElement = target.closest('[data-module-type][data-module-name]');
  if (!moduleElement) return null;

  const moduleType = moduleElement.dataset.moduleType || 'unknown';
  let elementValue = moduleElement.dataset.moduleName || '';
  let position = Number(moduleElement.dataset.modulePosition) || 1;

  if (moduleType === 'wide') {
    const slideElement = target.closest('[data-slide-position]');
    elementValue = slideElement?.dataset.slideName || '';
    position = Number(slideElement?.dataset.slidePosition) || 1;
  }

  return {
    event: `collection_module_${moduleType}`,
    section: 'collection_listing',
    element: `${moduleType}_module`,
    element_value: elementValue,
    interaction_type: interactionType,
    product_category: cp_product_category,
    element_position: position,
  };
};

function initializeCollectionAnalytics(root = document) {
  const collectionTileLinks = Array.from(root.querySelectorAll('.grid__item a')).filter((link) => {
    if (trackedCollectionLinks.has(link)) return false;
    trackedCollectionLinks.add(link);
    return true;
  });
  const collectionModules = Array.from(root.querySelectorAll('[data-module-type][data-module-name]')).filter(
    (element) => {
      if (trackedCollectionModules.has(element)) return false;
      trackedCollectionModules.add(element);
      return true;
    }
  );
  const collectionModuleLinks = Array.from(root.querySelectorAll('[data-module-click="true"]')).filter((link) => {
    if (trackedCollectionModuleLinks.has(link)) return false;
    trackedCollectionModuleLinks.add(link);
    return true;
  });
  if (collectionModules.length) {
    // Wide: view liczony per slajd (overflow slidera ucina niewidoczne slajdy), tile: per moduł.
    const moduleViewTargets = [];
    collectionModules.forEach((moduleElement) => {
      if (moduleElement.dataset.moduleType === 'wide') {
        moduleViewTargets.push(...moduleElement.querySelectorAll('[data-slide-position]'));
      } else {
        moduleViewTargets.push(moduleElement);
      }
    });

    const sendModuleImpression = async (target) => {
      if (target.dataset.impressionSent === 'true') return;
      target.dataset.impressionSent = 'true';

      const payload = buildModulePayload(target, 'view');
      if (payload) await dataLayerPromise(payload);
    };

    if ('IntersectionObserver' in window) {
      const moduleObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            sendModuleImpression(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.4,
        }
      );

      moduleViewTargets.forEach((target) => moduleObserver.observe(target));
    } else {
      collectionModules.forEach((moduleElement) => {
        const firstTarget =
          moduleElement.dataset.moduleType === 'wide'
            ? moduleElement.querySelector('[data-slide-position]')
            : moduleElement;
        if (firstTarget) sendModuleImpression(firstTarget);
      });
    }
  }

  if (collectionModuleLinks.length) {
    collectionModuleLinks.forEach((moduleLink) => {
      moduleLink.addEventListener('click', async (ev) => {
        const payload = buildModulePayload(moduleLink, 'click');
        if (!payload) return;

        if (moduleLink.getAttribute('target') === '_blank') {
          dataLayerPromise(payload);
          return;
        }

        ev.preventDefault();
        await dataLayerPromise(payload);
        continueLinkClickEvent(ev, moduleLink.href);
      });
    });
  }

  collectionTileLinks.forEach((link) => {
    link.addEventListener('click', async (ev) => {
      ev.preventDefault();
      const productName = link.getAttribute('data-product');
      await dataLayerPromise({
        event: 'product_tile_clicked',
        section: 'collection_listing',
        element: 'big_product_tile',
        element_value: productName ? productName : '',
        interaction_type: 'click',
        product_category: cp_product_category,
        position: Array.from(document.querySelectorAll('.grid__item a')).indexOf(link) + 1,
      });
      continueLinkClickEvent(ev, link.href);
    });
  });
}

initializeCollectionAnalytics();
document.addEventListener('collection:updated', (event) => {
  if (event.detail?.root) initializeCollectionAnalytics(event.detail.root);
});

const openFilterDrawer = document.getElementById('filter-drawer-button');

if (openFilterDrawer) {
  openFilterDrawer.addEventListener('click', () => {
    dataLayerPromise({
      event: 'filters_interaction',
      section: 'filters_modal_mobile',
      interaction_type: 'open',
    });
  });
}

const closeFilterDrawer = document.querySelector('.facets-close-modal');
if (closeFilterDrawer) {
  closeFilterDrawer.addEventListener('click', () => {
    dataLayerPromise({
      event: 'filters_interaction',
      section: 'filters_modal_mobile',
      interaction_type: 'close',
    });
  });
}

const showProductsButton = document.getElementById('show-products-button');

if (showProductsButton) {
  showProductsButton.addEventListener('click', () => {
    const span = showProductsButton.querySelector('span');
    let number_of_products_on_lisging = '';
    if (span) {
      number_of_products_on_lisging = span.textContent.replace(/[()]/g, '');
    }
    dataLayerPromise({
      event: 'filters_interaction',
      section: 'filters_modal_mobile',
      element: 'search_button',
      element_value: number_of_products_on_lisging,
      interaction_type: 'click',
    });
  });
}

const allProductsTiles = document.querySelectorAll('.subcategory-filters-wrapper .gifts-banner-swiper .swiper-slide a');

if (allProductsTiles.length) {
  allProductsTiles.forEach((tile) => {
    tile.addEventListener('click', async (ev) => {
      ev.preventDefault();

      const element_value = tile.getAttribute('data-collection');

      await dataLayerPromise({
        event: 'filters_interaction',
        section: 'collection_slider',
        element: 'photo_tile',
        element_value: element_value,
        interaction_type: 'click',
      });
      continueLinkClickEvent(ev, tile.href);
    });
  });
}

const bergainsCategoryLinks = document.querySelectorAll('.collection-page-bergains-nav a[data-collection]');

if (bergainsCategoryLinks.length) {
  bergainsCategoryLinks.forEach((link) => {
    link.addEventListener('click', async (ev) => {
      ev.preventDefault();

      const categoryName = link.getAttribute('data-collection');
      await dataLayerPromise({
        event: 'collection_tile_clicked',
        section: 'bergains_categories',
        element: 'collection_tile',
        element_value: categoryName,
        interaction_type: 'click',
      });
      continueLinkClickEvent(ev, link.href);
    });
  });
}
